import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SectionTitleSpecial from "../../components/SectionTitle/SectionTitleSpecial";
import SingleCourse from "../../components/Course";
import RightArrow from "../../components/SVG";
import courseBG from "../../assets/img/course/ed-bg-1.jpg";

const Course = ({ events, categoryMap }) => {
  const navigate = useNavigate();
  const handleNavigate = (id, title) => {
    navigate(`/event-details?eventId=${id}&&title=${title}`);
  };

  if (!events.length) return null;

  return (
    <div
      id="it-course"
      className="it-course-area ed-course-bg ed-course-style-3 p-relative pt-50 pb-50"
      style={{ backgroundImage: `url(${courseBG})` }}
    >
      <div className="container">
        <div className="ed-course-title-wrap mb-40">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-8 col-md-7">
              <SectionTitleSpecial
                itemClass="it-course-title-boxmb-70 section-title-fixed-width"
                subTitle="Our Events"
                preTitle="Knowledge Sharing Through "
                highlightText="Aquaculture"
                postTitle={`Events.`}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-5">
              <div className="it-blog-button text-start text-md-end mt-20">
                <Link className="ed-btn-theme" to="/event">
                  View All Events
                  <i>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {events?.map((event) => (
            <div className="col-xl-4 col-lg-6 col-md-6 mb-30" key={event._id}>
              <SingleCourse
                courseImage={event.image}
                thumbText={categoryMap[event.category._id]}
                title={event.title}
                edate={new Date(event.date).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
                content={
                  event.description?.replace(/<[^>]+>/g, "").slice(0, 120) +
                  "..."
                }
                btnClass="ed-btn-blog"
                hasArrow
                onClick={() => handleNavigate(event._id, event.title)}
                _id={event._id}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Course;
